import {
	addLoFComponent,
	addLoFConfig,
	getLoFConfigRejected,
	getLoFConfigResolved,
	setLoFConfig,
	setLoFComponents,
	setLoFComponent,
	saveLoFResolved,
	deleteCategory,
	getLoFInspectionFields,
	getLoFFieldsRejected,
	getLoFFieldsResolved,
	getLoFFields,
	getLoFInspectionFieldsRejected,
	getLoFInspectionFieldsResolved,
	setLofIsChanged,
} from '@Actions';
import { createReducer } from '@reduxjs/toolkit';
import { ComponentField, LoFStoreState } from '@Types';
import { sortFields } from '@Utils/sort';
import { AnyAction } from 'redux';

export const initState: LoFStoreState = {
	componentFields: [],
	componentInspectionFields: [],
	categories: [],
	isLoadingCategories: true,
	isLoadingFields: true,
	componentFieldsLoaded: false,
	isLoadingInspectionFields: true,
	componentInspectionFieldsLoaded: false,
	uniqueValue: [],
	isChanged: false,
	isValid: true,
};

interface LoFReducer {
	[x: string]: (
		state: LoFStoreState,
		action: AnyAction,
	) => LoFStoreState | undefined;
}

export const reducer: LoFReducer = {
	[getLoFConfigResolved.toString()]: (state, action) => ({
		...state,
		categories: action.payload,
		isLoadingCategories: false,
	}),
	[getLoFConfigRejected.toString()]: state => ({
		...state,
		isLoadingCategories: false,
	}),
	[addLoFConfig.toString()]: (state, action) => ({
		...state,
		categories: [...state.categories, action.payload],
		isChanged: true,
	}),
	[setLoFConfig.toString()]: (state, action) => ({
		...state,
		categories: action.payload,
		isChanged: true,
	}),
	[getLoFInspectionFields.toString()]: state => ({
		...state,
		componentInspectionFields: [],
		isLoadingInspectionFields: true,
		componentInspectionFieldsLoaded: false,
	}),
	[getLoFInspectionFieldsResolved.toString()]: (state, action) => {
		const fields: ComponentField[] = action.payload;
		return {
			...state,
			componentInspectionFields: sortFields(fields),
			isLoadingInspectionFields: false,
			componentInspectionFieldsLoaded: true,
		};
	},
	[getLoFInspectionFieldsRejected.toString()]: state => ({
		...state,
		isLoadingInspectionFields: false,
	}),
	[getLoFFields.toString()]: state => ({
		...state,
		componentFields: [],
		isLoadingFields: true,
		componentFieldsLoaded: false,
	}),
	[getLoFFieldsResolved.toString()]: (state, action) => {
		const fields: ComponentField[] = action.payload;
		return {
			...state,
			componentFields: sortFields(fields),
			isLoadingFields: false,
			componentFieldsLoaded: true,
		};
	},
	[getLoFFieldsRejected.toString()]: state => ({
		...state,
		isLoadingFields: false,
	}),
	[addLoFComponent.toString()]: (state, action) => ({
		...state,
		categories: state.categories.map(category =>
			category.name === action.payload.categoryName
				? {
						...category,
						components: [
							...category.components,
							action.payload.component,
						],
				  }
				: category,
		),
		isChanged: true,
	}),
	[setLoFComponent.toString()]: (state, action) => ({
		...state,
		categories: state.categories.map(category =>
			category.name === action.payload.categoryName
				? {
						...category,
						components: category.components.map(component =>
							component.name === action.payload.componentName
								? action.payload.component
								: component,
						),
				  }
				: category,
		),
		isChanged: true,
	}),
	[setLoFComponents.toString()]: (state, action) => ({
		...state,
		categories: state.categories.map(category =>
			category.name === action.payload.categoryName
				? {
						...category,
						components: action.payload.components,
				  }
				: category,
		),
		isChanged: true,
	}),
	[saveLoFResolved.toString()]: state => ({
		...state,
		isChanged: false,
	}),
	[deleteCategory.toString()]: (state, action) => {
		if (action.payload.forLoF) {
			return {
				...state,
				categories: state.categories.filter(
					category => category.name !== action.payload.categoryName,
				),
				isChanged: true,
			};
		} else {
			return { ...state };
		}
	},
	[setLofIsChanged.toString()]: (state, action) => ({
		...state,
		isChanged: action.payload,
	}),
};

export const lofReducer = createReducer(initState, reducer);
